export default {
  message: {
    title: '',
    preferVisitRead: '',
    preferVisitListten: '',
    preferVisitComplete: 'Completa',
    preferVisitShort: 'Curta',
    preferVisitSignoguia: 'Signoguia',
    titleVisitType: 'Visites guiades',
    titleMenu: 'Menú',
    moreInfo:'Saber-ne més?',
    moreInfoNo: 'No',
    moreInfoYes:'Sí',
    downloadAudio: '(Descàrrega d\'àudios)',
    download: 'Descàrrega dels arxius',
    downloadVideo: '(Descàrrega de videos)',
    downloadSignoguia: 'Descàrrega dels arxius de video',
    errorDownload: 'Hi ha hagut un error en la descàrrega. Torna a intentar-ho',
    cancelDownload: 'Has cancel·lat la descàrrega.',
    retry: 'Reintentar',
    noConnection: 'No tens conexió a internet',
    titleMap: 'SELECCIONE UN NÚMERO',
    map: 'mapa_esp.png',

    initDownload: 'Por favor, espere mientras se descargan los audios',
    endDownload: 'Audios descargados. ¡Disfrute de la visita!',



    menuItems: [
        {
            img: '1a.jpg',
            imageMenu: '',
            title: '  PULSE PLAY',
            author: '',
            description: '',
            audio: '1.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '1a.jpg',
                    second: '0'
                },
                {
                    img: '1b.jpg',
                    second: '46'
                },
            ],
        },
        {
            img: '2.jpg',
            imageMenu: '',
            title: '2. PURIFICACIÓN',
            author: '',
            description: '',
            audio: '2.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '3.jpg',
            imageMenu: '',
            title: '3. CONDENA',
            author: '',
            description: '',
            audio: '3.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '4.jpg',
            imageMenu: '',
            title: '4. CAÍDA',
            author: '',
            description: '',
            audio: '4.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '5.jpg',
            imageMenu: '',
            title: '5. MARCOS',
            author: '',
            description: '',
            audio: '5.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '6.jpg',
            imageMenu: '',
            title: '6. LUCAS',
            author: '',
            description: '',
            audio: '6.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '7.jpg',
            imageMenu: '',
            title: '7. TOMÁS',
            author: '',
            description: '',
            audio: '7.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '8a.jpg',
            imageMenu: '',
            title: '8. SANTIAGO EL MENOR',
            author: '',
            description: '',
            audio: '8.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '8a.jpg',
                    second: '0'
                },
                {
                    img: '8b.jpg',
                    second: '60'
                },
            ],
        },
        {
            img: '9.jpg',
            imageMenu: '',
            title: '9. SANTIAGO EL MAYOR',
            author: '',
            description: '',
            audio: '9.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '10a.jpg',
            imageMenu: '',
            title: '10. FELIPE',
            author: '',
            description: '',
            audio: '10.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '10a.jpg',
                    second: '0'
                },
                {
                    img: '10b.jpg',
                    second: '59'
                },
            ],
        },
        {
            img: '11.jpg',
            imageMenu: '',
            title: '11. ANDRÉS',
            author: '',
            description: '',
            audio: '11.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '12.jpg',
            imageMenu: '',
            title: '12. BARTOLOMÉ',
            author: '',
            description: '',
            audio: '12.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '13.jpg',
            imageMenu: '',
            title: '13. PEDRO Y PABLO',
            author: '',
            description: '',
            audio: '13.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '14a.jpg',
            imageMenu: '',
            title: '14. SIMÓN Y JUDAS',
            author: '',
            description: '',
            audio: '14.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '14a.jpg',
                    second: '0'
                },
                {
                    img: '14b.jpg',
                    second: '20'
                },
                {
                    img: '14c.jpg',
                    second: '36'
                },
            ],
        },
        {
            img: '15.jpg',
            imageMenu: '',
            title: '15. JUAN',
            author: '',
            description: '',
            audio: '15.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '16.jpg',
            imageMenu: '',
            title: '16. MATEO',
            author: '',
            description: '',
            audio: '16.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '17.jpg',
            imageMenu: '',
            title: '17. PECADO',
            author: '',
            description: '',
            audio: '17.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '18.jpg',
            imageMenu: '',
            title: '18. MUERTE',
            author: '',
            description: '',
            audio: '18.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '19.jpg',
            imageMenu: '',
            title: '19. GUERRA',
            author: '',
            description: '',
            audio: '19.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '20.jpg',
            imageMenu: '',
            title: '20. PARAÍSO CERRADO',
            author: '',
            description: '',
            audio: '20.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '21a.jpg',
            imageMenu: '',
            title: '21. CRUCIFIXIÓN',
            author: '',
            description: '',
            audio: '21.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '21a.jpg',
                    second: '0'
                },
                {
                    img: '21b.jpg',
                    second: '123'
                },
            ],
        },
        {
            img: '22.jpg',
            imageMenu: '',
            title: '22. ENTIERRO',
            author: '',
            description: '',
            audio: '22.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '23.jpg',
            imageMenu: '',
            title: '23. ASCENSIÓN',
            author: '',
            description: '',
            audio: '23.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '24.jpg',
            imageMenu: '',
            title: '24. MARCOS',
            author: '',
            description: '',
            audio: '24.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '25.jpg',
            imageMenu: '',
            title: '25. LUCAS',
            author: '',
            description: '',
            audio: '25.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '26.jpg',
            imageMenu: '',
            title: '26. JUAN',
            author: '',
            description: '',
            audio: '26.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '27.jpg',
            imageMenu: '',
            title: '27. MATEO',
            author: '',
            description: '',
            audio: '27.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '28.jpg',
            imageMenu: '',
            title: '28. ESPACIO SERT',
            author: '',
            description: '',
            audio: '28.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '29a.jpg',
            imageMenu: '',
            title: '29. PINTURAS',
            author: '',
            description: '',
            audio: '29.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '29a.jpg',
                    second: '0'
                },
                {
                    img: '29b.jpg',
                    second: '60'
                },
            ],
        },
        {
            img: '30.jpg',
            imageMenu: '',
            title: '30. MAQUETA',
            author: '',
            description: '',
            audio: '30.mp3',
            video: '',
            visitType: '{all}',
        },

        {
            img: '31.jpg',
            imageMenu: 'thumb_2.png',
            title: 'Créditos',
            author: '',
            description: 'Guion, producción, diseño y programación: Trama Media.<br><br>Agradecimientos: Obispado de Vic.<br><br>Fotografías: Pepo Segura, Guillem Mercadal, MNAC, CRBMC.<br><br>Textos bíblicos:<i>Sagrada Biblia. Versión oficial de la Conferencia Episcopal Española </i>(CEE). Biblioteca de Autores Cristianos, Madrid, 2011.<br><br>Otros textos: Josep Torras i Bages, <i>La ciència del patir.</i> Foment de la Pietat Catalana, Barcelona, 1927.<br><br>Trama Media ha hecho todo lo posible por obtener las autorizaciones necesarias para todos los contenidos reproducidos en esta guía. No obstante, si desea formular alguna reclamación relativa a la propiedad intelectual, no dude en ponerse en contacto con nosotros.<br><br>© de las fotografías y los textos citados: los autores.<br>© del resto: Trama Media.<br><br>',
            audio: '',
            visitType: '{all}',
            moreInfoItem: '',
            isCredits: true,

        }
    ]
  },
}



// WEBPACK FOOTER //
// ./src/data/i18n/castellano.js